import React, { useContext, useRef } from 'react';

import { getNameExtension } from '@shared/helpers';
import { makeDecodeURL } from '@shared/helpers/makeDecodeURL';
import { ContextFiles } from '@widgets/Files/model/context';
import { IFIleEntity } from '@widgets/Files/model/types/fileEntity.interface';

export const useFileCard = (fileInfo: IFIleEntity) => {
    const { onChangeModalMode, onChangeCurrentFile } = useContext(ContextFiles);

    const decodeNameFile = makeDecodeURL(fileInfo.name, true);
    const dragPreviewRef = useRef<HTMLElement | null>(null);

    const { name, extension } = getNameExtension(decodeNameFile);

    const substringFileName = (fileName: string, fileType: string) => {
        let subName = '';
        if (fileName.length > 22) {
            subName = `${fileName.substring(0, 22)}...${fileType}`;
        } else {
            subName = `${fileName}.${fileType}`;
        }

        return subName;
    };

    const handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
        const previewWrapper = document.createElement('div');
        previewWrapper.style.width = '72px';
        previewWrapper.style.height = '72px';
        previewWrapper.style.background = 'white';
        previewWrapper.style.display = 'flex';
        previewWrapper.style.alignItems = 'center';
        previewWrapper.style.justifyContent = 'center';
        previewWrapper.style.borderRadius = '8px';
        previewWrapper.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
        previewWrapper.style.position = 'absolute';
        previewWrapper.style.top = '-9999px';
        previewWrapper.style.left = '-9999px';

        let previewContent: HTMLElement;

        const img = document.createElement('img');
        img.src = fileInfo.previewSvgUrl;
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';
        previewContent = img;

        previewWrapper.appendChild(previewContent);
        document.body.appendChild(previewWrapper);

        dragPreviewRef.current = previewWrapper;

        e.dataTransfer.setDragImage(previewWrapper, 36, 36);
        e.dataTransfer.setData('data-file-id', String(fileInfo.id));
        e.dataTransfer.setData('file-type', String('file'));
    };

    const handleDragEnd = () => {
        if (dragPreviewRef.current) {
            document.body.removeChild(dragPreviewRef.current);
            dragPreviewRef.current = null;
        }
    };

    const finalFileName = substringFileName(name, extension);

    return {
        onChangeModalMode,
        onChangeCurrentFile,
        handleDragStart,
        handleDragEnd,
        finalFileName,
    };
};
